// Marked as ours: a merge joins layers and inks by name, so a customer file's
// own "cut" or "help" never becomes one of these.
export const OwnName = <T extends string>(name: string): T => `⌖ ${name}` as T
